import React, { useRef, useEffect } from "react";
import { useWindowSize } from "shared/hooks/resize";
import classNames from "classnames";

const Container = ({ children, className }) => {
  const ref = useRef(null);
  const [, height] = useWindowSize();

  useEffect(() => {
    if (ref.current && height) {
      ref.current.style.minHeight = `${height}px`;
    }
  }, [height]);

  const wrapperClass = classNames(className || "container");

  return (
    <div ref={ref} className={wrapperClass}>
      {className ? <div className="container">{children}</div> : children}
    </div>
  );
};

export default Container;
